export const GET_PRODUCT_LOCATIONS = "GET_PRODUCT_LOCATIONS";
export const GET_PRODUCT_LOCATION = "GET_PRODUCT_LOCATION";
export const ADD_PRODUCT_LOCATION = "ADD_PRODUCT_LOCATION";
export const DELETE_PRODUCT_LOCATION = "DELETE_PRODUCT_LOCATION";
export const UPDATE_PRODUCT_LOCATION = "UPDATE_PRODUCT_LOCATION";
